<script setup lang="ts">
interface ActiveFilter {
  key: string
  label: string
  type?: string
  minSelected?: number
  maxSelected?: number
  options?: Array<{
    key: string
    label: string
    active?: boolean
  }>
}

const { t: $t } = useI18n()

defineProps<{
  activeFilters: Record<string, ActiveFilter>
}>()

defineEmits(['filters-reset-all', 'filter-reset-range-min', 'filter-reset-range-max', 'option-toggle'])
</script>

<template>
  <div class="filter-active">
    <div class="filter-active__heading">
      {{ $t('Active Filters') }}
    </div>

    <ol class="filter-active__list">
      <template
        v-for="filter in activeFilters"
        :key="filter.key"
      >
        <template v-if="filter.type === 'range'">
          <li
            v-if="filter.minSelected"
            class="filter-active__item"
          >
            <button
              type="button"
              class="filter-active__link"
              @click="$emit('filter-reset-range-min', filter.key)"
            >
              <span>{{ $t(filter.label) }}: {{ filter.minSelected }}</span>
              <Icon
                name="icon:close"
                class="icon icon--close"
              />
            </button>
          </li>
          <li
            v-if="filter.maxSelected"
            class="filter-active__item"
          >
            <button
              type="button"
              class="filter-active__link"
              @click="$emit('filter-reset-range-max', filter.key)"
            >
              <span>{{ $t(filter.label) }}: {{ filter.maxSelected }}</span>
              <Icon
                name="icon:close"
                class="icon icon--close"
              />
            </button>
          </li>
        </template>
        <template v-else>
          <template
            v-for="option in filter.options"
            :key="option"
          >
            <li class="filter-active__item">
              <button
                v-if="option?.active"
                type="button"
                class="filter-active__link"
                @click="$emit('option-toggle', filter.key, option.key)"
              >
                <span>{{ $t(filter.label) }}: {{ $t(option.label) }}</span>
                <Icon
                  name="icon:close"
                  class="icon icon--close"
                />
              </button>
            </li>
          </template>
        </template>
      </template>
    </ol>

    <button
      type="button"
      class="filter-active__clear"
      @click="$emit('filters-reset-all')"
    >
      <span>{{ $t('Clear All') }}</span>
    </button>

    <!-- <pre>activeFilters: {{ activeFilters }}</pre> -->
  </div>
</template>

<style>
  @import url("~layers/app/components/Filter/Active.css");
</style>
